var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewPredecessor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1723_603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66683 14H12.6668C13.0205 14 13.3596 13.8595 13.6096 13.6095C13.8597 13.3594 14.0002 13.0203 14.0002 12.6667V8.66667H11.3335V10L8.66683 8L11.3335 6V7.33333H14.0002V3.33333C14.0002 2.97971 13.8597 2.64057 13.6096 2.39052C13.3596 2.14048 13.0205 2 12.6668 2H2.66683C2.31321 2 1.97407 2.14048 1.72402 2.39052C1.47397 2.64057 1.3335 2.97971 1.3335 3.33333V12.6667C1.3335 13.0203 1.47397 13.3594 1.72402 13.6095C1.97407 13.8595 2.31321 14 2.66683 14ZM2.66683 10H5.3335V11.3333H2.66683V10ZM2.66683 7.33333H7.3335V8.66667H2.66683V7.33333ZM2.66683 4.66667H7.3335V6H2.66683V4.66667ZM14.0002 7.33333H16.0002V8.66667H14.0002V7.33333Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1723_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewPredecessor);
export default __webpack_public_path__ + "static/media/icon--new-predecessor.dca7a5e906abe57b65098d26fd30ee62.svg";
export { ForwardRef as ReactComponent };